import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import LocalIcons from './LocalIcons';
import {
    faUser,
    faArrowUp,
    faArrowDown,
    faMinus,
    faPlus,
    faCaretUp,
    faCaretRight,
    faCaretDown,
    faCaretLeft,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faUser,
    faArrowUp,
    faArrowDown,
    faMinus,
    faPlus,
    faCaretUp,
    faCaretRight,
    faCaretDown,
    faCaretLeft,
    );


export default function Icons({ familyName, iconName, transformScale = 1, fontAwesomeSize = '1x', color, style = {}, rotateDeg = 0 }) {
   
    switch (familyName) {
        case 'fa':
        case 'fas':
        case 'fab':
            return <FontAwesomeIcon style={{color: color ?? 'none', ...style}} icon={[familyName, iconName]} size={fontAwesomeSize} />
        case 'vec':
            return <LocalIcons iconName={iconName} color={color} style={style} transformScale={transformScale} rotateDeg={rotateDeg} />
        default:
            return <i className={`ni ${iconName}`}></i>
    }
}

// note: Find icon list here: https://fontawesome.com/search?o=r&s=solid